/**
 * Servicio para gestión de catálogo de almacenes
 */

import api from './api.js';

class AlmacenService {
  /**
   * Listar almacenes con filtros
   */
  async listar(params = {}) {
    // Limpiar parámetros vacíos
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        cleanParams[key] = params[key];
      }
    });
    return await api.get('/almacenes', cleanParams);
  }

  /**
   * Listar solo almacenes activos (para selects)
   */
  async listarActivos() {
    return await api.get('/almacenes/activos');
  }

  /**
   * Obtener almacén por ID
   */
  async obtenerPorId(id) {
    return await api.get(`/almacenes/${id}`);
  }

  /**
   * Crear nuevo almacén
   */
  async crear(data) {
    return await api.post('/almacenes', data);
  }

  /**
   * Actualizar almacén
   */
  async actualizar(id, data) {
    return await api.put(`/almacenes/${id}`, data);
  }

  /**
   * Activar/Desactivar almacén
   */
  async toggleActivo(id) {
    // Para PATCH usamos fetch directamente ya que api.js no tiene método patch
    const response = await fetch(`${api.baseUrl}/almacenes/${id}/toggle`, {
      method: 'PATCH',
      headers: api.getHeaders()
    });
    return await api.handleResponse(response);
  }

  /**
   * Eliminar almacén
   */
  async eliminar(id) {
    return await api.delete(`/almacenes/${id}`);
  }

  /**
   * Obtener estadísticas
   */
  async obtenerEstadisticas() {
    return await api.get('/almacenes/stats');
  }
}

export default new AlmacenService();
